import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ActionIcon, Box, Text } from '@mantine/core';
import { IconHome2, IconMessageDots, IconUser } from '@tabler/icons-react';
import { useAtom } from 'jotai';
import { activePageAtom } from '../../stores/atoms';
// import { useSetAtom } from 'jotai';
// import { editingMineIdAtom } from '@/stores/atoms/uiAtoms';
import { useT } from '@/i18n';
const NavItem = ({ label, icon, active, onClick }) => (_jsxs(Box, { className: "nav-item", onClick: onClick, role: "button", tabIndex: 0, "aria-label": label, onKeyDown: (e) => {
        if (e.key === 'Enter' || e.key === ' ')
            onClick();
    }, style: {
        cursor: 'pointer',
        textAlign: 'center',
        flex: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
    }, children: [_jsx(ActionIcon, { size: "xl", variant: active ? 'filled' : 'light', children: icon }), _jsx(Text, { size: "xs", mt: 4, c: active ? 'blue' : 'dimmed', children: label })] }));
const BottomNav = () => {
    const [active, setActive] = useAtom(activePageAtom);
    // const setEditingId = useSetAtom(editingMineIdAtom);
    const t = useT();
    return (_jsxs(Box, { className: "bottom-nav", style: {
            display: 'flex',
            width: '100%',
            // Keep nav controls within the visible bar area (excluding safe-area padding on footer)
            height: 'var(--footer-bar-height, 64px)'
        }, children: [_jsx(NavItem, { label: t('nav.home'), icon: _jsx(IconHome2, { size: 20 }), active: active === 'home', onClick: () => setActive('home') }), _jsx(NavItem, { label: t('nav.chat'), icon: _jsx(IconMessageDots, { size: 20 }), active: active === 'chat', onClick: () => setActive('chat') }), _jsx(NavItem, { label: '我的', icon: _jsx(IconUser, { size: 20 }), active: active === 'mine', onClick: () => setActive('mine') })] }));
};
export default BottomNav;
